import React, { Component } from 'react';
import PropTypes from 'prop-types';
import List from 'material-ui/List';
import NavItem from './NavItem';

class NavItems extends Component{
  render(){
    const { navPaths, onItemClick } = this.props;
    const items = navPaths
    .filter(item => !item.hide)
    .map((item)=> (
      <NavItem 
        key={item.path}
        path={item.path}
        onClick={onItemClick}
        disabled={item.disabled}
      >
        { item.title }
      </NavItem>
    ));

    return (
        <List>
          { items }
        </List>
    );
  }
}

NavItems.propTypes = {
  onItemClick: PropTypes.func.isRequired,
  navPaths:    PropTypes.array.isRequired,
}

export default NavItems;



// WEBPACK FOOTER //
// ./src/components/NavItems.js